import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {CircleButton} from '../../atoms/Buttons/CircleButton';
import {Icon, IconSize} from '../../atoms/Icon/Icon';
import {IconName} from '../../atoms/Icon/IconName';
import {Tooltip} from '../../atoms/Tooltip/Tooltip';

export interface HeaderButtonProps {
  className?: string;
  label: string;
  textColor?: keyof typeof COLORS;
  icon: IconName;
  iconSize?: keyof typeof IconSize;
  iconColor?: COLORS;
  backgroundColor?: COLORS | 'transparent';
  onClick: VoidFunction;
  dataTestId?: string;
}

export const HeaderCircleButton: React.FC<HeaderButtonProps> = ({
  className,
  label,
  icon,
  iconSize = 'S',
  iconColor = COLORS.Grey1,
  backgroundColor = COLORS.White,
  onClick,
  dataTestId,
}) => {
  return (
    <Tooltip label={label} placement="bottom-center">
      <StyledCircleButton
        $backgroundColor={backgroundColor}
        data-testid={dataTestId}
        className={className}
        onClick={onClick}
        aria-label={undefined}
      >
        <Icon
          data-testid={`${dataTestId}_Icon`}
          asset={icon}
          size={iconSize}
          fill={iconColor}
        />
      </StyledCircleButton>
    </Tooltip>
  );
};

const StyledCircleButton = styled(CircleButton)<{
  $backgroundColor: COLORS | 'transparent';
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-basis: 40px;
  height: 40px;
  width: 40px;
  border-radius: 50%;

  background-color: ${({$backgroundColor}) => $backgroundColor ?? ''};
  box-shadow: ${({$backgroundColor}) =>
    $backgroundColor === COLORS.White
      ? `0px 2px 3px rgba(0, 0, 0, 0.08),
        0px 3px 12px 2px rgba(0, 0, 0, 0.07)`
      : 'none'};

  &:hover {
    svg {
      fill: ${({$backgroundColor}) =>
        $backgroundColor === COLORS.White ? COLORS.Black : COLORS.Grey1};
    }
  }
`;
